import React, { useEffect, useRef, useState } from 'react';

import { usePortfolio } from '../../contexts/PortfolioContext';
import { EditPortfolioAccountModal, type PortfolioAccountDraft } from './EditPortfolioAccountModal';

const EMPTY_DRAFT: PortfolioAccountDraft = { label: '', balance: 0 };

/**
 * Global add sheet for Net worth → Other assets / Active investments shortcuts.
 * List cards still own their own local + / edit modals.
 */
export function PortfolioAccountSheetHost() {
  const {
    addAccountRequestId,
    pendingAddIsInvestment,
    addAccount,
    mutating,
  } = usePortfolio();
  const [visible, setVisible] = useState(false);
  const [isInvestment, setIsInvestment] = useState(true);
  /** Capture at open so Save never races a stale React state value. */
  const isInvestmentRef = useRef(true);

  useEffect(() => {
    if (addAccountRequestId <= 0) return;
    isInvestmentRef.current = pendingAddIsInvestment;
    setIsInvestment(pendingAddIsInvestment);
    setVisible(true);
  }, [addAccountRequestId, pendingAddIsInvestment]);

  return (
    <EditPortfolioAccountModal
      visible={visible}
      mode="add"
      category={isInvestment ? 'investment' : 'other'}
      initial={EMPTY_DRAFT}
      saving={mutating}
      onClose={() => setVisible(false)}
      onSave={(draft) => {
        const asInvestment = isInvestmentRef.current;
        void addAccount({
          ...draft,
          isInvestment: asInvestment,
          expectedReturnPct: asInvestment ? draft.expectedReturnPct : undefined,
        })
          .then(() => setVisible(false))
          .catch(() => {
            // error via context
          });
      }}
    />
  );
}
